import { inject, Injectable, signal } from '@angular/core';
import { AppApi } from '@api/AppApi';
import { PublicAppInfo } from '@api/model/my-api';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  protected appApi = inject(AppApi);
  private _version$$ = signal<PublicAppInfo | undefined>(undefined);
  public version$$ = this._version$$.asReadonly();

  constructor() {
    this.appApi.appInfoEndpoint.info().subscribe((res) => {
      console.table(res);
      this._version$$.set(res);
    });
  }
}
